import ApiLocation from 'types/api/Location';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import Element from 'types/redux/Element';
import ListCollection from 'types/redux/ListCollection';

import Location from 'models/Location';

import { ELEMENT_MARKUP, LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    citySlug?: string,
    voivodeshipSlug?: string;
    postalCode?: string;
    location?: string;
    productId?: string;
    productIds?: string[];
    excludeIds?: string[];
    lat?: number;
    lng?: number;
    distance?: number;
    resource?: string;
    simpleSearch?: string;
    handlingByCategoryId?: string;
    handlingByCategoryName?: string;
}

export const list = async (params?: ListParams): Promise<ListCollection<Location>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicLocations, params),
        requestParams: params,
        params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.Locations];

    if (!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiLocation) => new Location(element)),
        meta: resource.meta,
    };
};


export interface ListNearbyParams {
    citySlug?: string,
    voivodeshipSlug?: string;
    perPage?: number;
    ignoreIds?: string[];
}

export const listNearby = async (params?: ListNearbyParams): Promise<ListCollection<Location>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicLocationsNearby, params),
        requestParams: params,
        params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.Locations];

    if (!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource.map((element: ApiLocation) => new Location(element)),
        meta: null,
    };
};

export interface SingleParams {
    slug: string;
}

export const single = async (params: SingleParams): Promise<Element<Location>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicLocation, params),
    });

    const data = response?.payload?.data;
    const resource: ApiLocation = data && data[ApiResources.Location];

    if (!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...ELEMENT_MARKUP,
        isLoaded: true,
        data: new Location(resource),
    };
};

//Google My Business link
export interface GmbLinkParams {
    slug: string;
}

export const gmbLink = async (params: GmbLinkParams): Promise<Element<Location>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicLocationsGmb, params),
    });

    const data = response?.payload?.data;
    const resource = data?.locationGmbLink;

    if (!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...ELEMENT_MARKUP,
        isLoaded: true,
        data: resource,
    };
};
